<script setup>
import { computed, onMounted, ref, watch, nextTick } from 'vue';
import { useStore } from 'vuex';
import { useMapGetter } from 'dashboard/composables/store';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import { useEmitter } from 'dashboard/composables/emitter';
import { useAlert } from 'dashboard/composables';
import {
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper.js';
import CardLayout from 'dashboard/components-next/CardLayout.vue';
import UserDetailsDialog from "./UserDetailsDialog.vue";

const { currentChat } = defineProps({
  currentChat: {
    type: Object,
    default: null,
  },
});

const store = useStore();
// 从 Store 中获取 UI 状态
const uiFlags = useMapGetter('giftCards/getUIFlags');
const fetchingUserList = computed(() => uiFlags.value.fetchingUserList);
const currentUser = useMapGetter('getCurrentUser');
const currentAccountId = useMapGetter('getCurrentAccountId');
const currentUserId = ref(0);
const refUserDetailsDialog = ref(null);
// const userPermissions = computed(() => {
//   return getUserPermissions(currentUser.value, currentAccountId.value);
// });
//
// const showWithdrawButton = computed(() => {
//   return !hasPermissions(['encrypt_message'], userPermissions.value);
// });

// 动态获取订单列表
const users = computed(() => {
  return store.getters['giftCards/getUserList'];
});

const fetchUserList = async () => {
  await store.dispatch('giftCards/getUserList', {
    conversation_id: currentChat.id,
  });
};

const handleClick = user_id => {
  currentUserId.value = user_id;
  refUserDetailsDialog.value?.userInfoDialogRef.open();
};

// 页面加载时获取订单列表
onMounted(() => {
  fetchUserList();
});
</script>

<template>
  <div class="flex flex-col gap-4 pt-2">
    <div
      v-if="fetchingUserList"
      class="flex items-center justify-center py-10 text-n-slate-11"
    >
      <Spinner />
    </div>
    <template v-else-if="users && users.length">
      <CardLayout v-for="user in users" :key="user.user_id" layout="row">
        <div class="flex justify-between items-center w-full">
          <!-- 用户 ID 和品牌 -->
          <div class="text-sm font-medium text-gray-800">
            <woot-button
              color-scheme="success"
              variant="link"
              @click="handleClick(user.user_id)"
            >
              {{ user.user_id }} - {{ user.brand_name }}
            </woot-button>
          </div>
          <!-- 订单成功量 / 总量 -->
          <div
            class="flex items-center m-0 text-sm font-medium text-n-slate-11"
          >
            {{ user.handling }}/{{ user.all }}
            <fluent-icon
              v-tooltip="
                'This represents the user’s successful orders and total orders.'
              "
              data-test-id="orderHandling"
              size="14"
              icon="info"
              class="text-n-slate-11 my-0 mx-1 mt-0.5"
            />
          </div>
        </div>
      </CardLayout>
    </template>
    <div v-else class="text-center text-gray-500">No users found.</div>
  </div>

  <UserDetailsDialog :id="currentUserId" ref="refUserDetailsDialog" />
</template>
